import { useMemo } from 'react'
import { useSolanaWallets } from '@towns/privy'

export const useSolanaWallet = () => {
    const { wallets: solanaWallets } = useSolanaWallets()
    const solanaWallet = useMemo(() => {
        return solanaWallets.find((wallet) => wallet.walletClientType === 'privy')
    }, [solanaWallets])
    return { solanaWallet }
}
